import { render, staticRenderFns } from "./ListImportantQuestions.vue?vue&type=template&id=cc138bbe"
import script from "./ListImportantQuestions.vue?vue&type=script&lang=js"
export * from "./ListImportantQuestions.vue?vue&type=script&lang=js"
import style0 from "./ListImportantQuestions.vue?vue&type=style&index=0&id=cc138bbe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports